import { useDataChange } from 'Simple/Data.js'
import { useEffect, useCallback } from 'react'
import View from './view.js'
import query from './query-person-by-id.graphql.js'
import { useClient } from 'Data/Api.js'
import { notifyError } from 'Logic/Notifications.js'

export default function Logic(props) {
  let client = useClient()
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let resolve_person_vaxiom_id = useCallback(
    async person_id => {
      if (!person_id) return null

      let { data, error } = await client
        .query(query, { id: person_id })
        .toPromise()
      if (error) {
        throw error
      }

      return data?.vaxiom_persons?.[0]?.id || null
    },
    [client]
  )

  useEffect(() => {
    if (props.personId && typeof props.personId === 'string') {
      resolve_person_vaxiom_id(props.personId)
        .then(vaxiom_id => {
          change(next => {
            next.send_to_person_id = props.personId
            next.send_to_person_vaxiom_id = vaxiom_id
          })
        })
        .catch(error => {
          console.error('Error resolving person vaxiom_id:', error)
          notifyError(
            'Failed to resolve person ID. Please check the provided personId.'
          )
        })
    }
  }, [props.personId]) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
